import { Box, InputLabel, TextField, Typography } from "@mui/material";
import MainModal from "components/MainModal";
import { useRCAMainStyles } from "pages/Corporate/RCA/RCA.styles";
import { useState } from "react";
import { IAddSecondaryItemModal } from "../RCAFishboneDiagramInterfaces";
import { useTranslation } from "react-i18next";

const AddNewSecondaryItemModal = ({
    open,
    onClose,
    parentMainItem,
    onSaveNewSecondaryItem,
    disabled,
}: IAddSecondaryItemModal) => {
    const mainClasses = useRCAMainStyles();
    const { t } = useTranslation();

    const [addNewItemTextDescription, setAddNewItemTextDescription] = useState<string | null | undefined>("");

    const handleOnClose = () => {
        setAddNewItemTextDescription("");
        onClose();
    };

    return (
        <MainModal
            isOpen={open}
            onClose={handleOnClose}
            title={t("rca.rca_library.rca_detail.fishbone_diagram.secondary_item", {
                item: parentMainItem?.description,
            })}
            showCloseButton
            customModalStyles={{ width: 600 }}
            onOkButtonClick={() => {
                onSaveNewSecondaryItem(parentMainItem!, addNewItemTextDescription!);
                handleOnClose();
            }}
            okButton={t("rca.rca_library.rca_detail.fishbone_diagram.save")}
            disableOkButton={!addNewItemTextDescription?.trim() || disabled}
        >
            <Box className={`${mainClasses.contentFormBox} ${mainClasses.contentCardContent}`}>
                <InputLabel id="outlined-actionPlanDescription-label">
                    <Typography variant="subtitle2" className={mainClasses.contentFormLabelMaxWidth}>
                        {t("rca.rca_library.rca_detail.fishbone_diagram.secondary_item_title")}
                    </Typography>
                </InputLabel>
                <TextField
                    fullWidth
                    className={mainClasses.contentFormMultitextField}
                    multiline
                    rows={3}
                    type="text"
                    placeholder={t("rca.rca_library.rca_detail.fishbone_diagram.secondary_item_placeholder")}
                    variant="outlined"
                    value={addNewItemTextDescription}
                    onChange={(e) => setAddNewItemTextDescription(e.target.value)}
                />
            </Box>
        </MainModal>
    );
};

export default AddNewSecondaryItemModal;
